import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import HeadingM from "../shared/HeadingM"
import Map from "../shared/about/Map"

const Detail = () => {
  const data = [
    { label: "店舗名", value: "Do CAFE" },
    { label: "営業時間", value: "月～金 ／ 11:00〜17:00\n土曜日(11月〜4月) ／ 11:00～17:00\n土曜日(5月〜10月) ／ 11:00～18:00" },
    { label: "定休日", value: "日曜日" },
    { label: "住所", value: "〒378-0016 群馬県沼田市清水町４２０８−１" },
    { label: "連絡先", value: "080-3442-9975" },
  ]

  const parameters = 'pb=!1m18!1m12!1m3!1d689.1116006078408!2d139.03551806651944!3d36.64403188066864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601e69ea6743e0db%3A0x941eaf0de1de2522!2sDOCAFE!5e0!3m2!1sja!2sjp!4v1747295531904!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

  return (
    <div id="info" className="pt-12">
      <HeadingM title="店舗詳細" target="doCafe" />
      <div className="flex flex-col-reverse justify-between mt-12 md:mt-16 md:flex-row md:space-x-8">
        <ul className="mt-5 md:mt-0">
          {data.map(item => (
            <div key={item.label}>
              <li
                className="relative grid grid-cols-4 py-4 border-dashed md:py-7 border-Brown"
                key={item.label}
              >
                <div className="col-span-1">{item.label}</div>
                <div className="col-span-3 whitespace-pre-wrap">
                  {item.value}
                  {item.label === "住所" && (
                    <a
                      href="https://maps.app.goo.gl/QKPCb52wErBPHShP8"
                      className="block text-xs text-blue-500 underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Googleマップで開く
                    </a>
                  )}
                </div>
              </li>
              <div className="border-dash" />
            </div>
          ))}
        </ul>
        <StaticImage
          src="../../images/do-cafe/building.jpg"
          alt="cafe"
          className="m-auto md:w-1/2 rounded-3xl h-96 md:ml-5"
        />
      </div>
      <Map parameters={ parameters } />
    </div>
  )
}

export default Detail
